export const LEXICAL_LEARNING_STAGES = [
  'skim',
  'learn_pronunciation',
  'quiz_matching',
  'quiz_meaning_to_lexical',
  'quiz_lexical_to_meaning',
  'review_speaking',
  'review_typing',
  'complete',
] as const

export type LexicalLearningStage = typeof LEXICAL_LEARNING_STAGES[number]
export type LexicalLearningPracticeStage = Exclude<LexicalLearningStage, 'skim' | 'complete'>
export type LexicalLearningQuizStage = Extract<LexicalLearningPracticeStage,
  'quiz_matching' | 'quiz_meaning_to_lexical' | 'quiz_lexical_to_meaning'>
export type LexicalLearningReviewStage = Extract<LexicalLearningPracticeStage,
  'review_speaking' | 'review_typing'>
export type LexicalLearningStageStatus = 'not_started' | 'in_progress' | 'completed' | 'skipped'

export interface LexicalLearningStageProgress {
  status: LexicalLearningStageStatus
  queue: string[]
  current_index: number
  completed_ids: string[]
  best_scores: Record<string, number>
  streaks: Record<string, number>
  reveal_counts: Record<string, number>
  review_rounds: number
}

export interface LexicalLearningActivityProgress {
  version: 1
  current_stage: LexicalLearningStage
  selected_token_keys: string[]
  selected_lexical_ids: string[]
  quiz_lexical_ids: string[]
  quiz_available: boolean
  stages: Record<LexicalLearningPracticeStage, LexicalLearningStageProgress>
  completed: boolean
}

export interface LexicalLearningSession extends LexicalLearningActivityProgress {
  passage_id: string
  skim_draft_token_keys: string[]
  skim_draft_lexical_ids: string[]
  hydrated: boolean
  revision: number
}

export interface LexicalLearningItem {
  id: string
  text: string
  type: string
  meaning: string
  phonemes: string | null
  audio: string | null
  image: string | null
  contexts: Array<{
    sentence_id: string
    sentence_text: string
    token_indexes: number[]
  }>
}

export const PRACTICE_STAGES: LexicalLearningPracticeStage[] = [
  'learn_pronunciation',
  'quiz_matching',
  'quiz_meaning_to_lexical',
  'quiz_lexical_to_meaning',
  'review_speaking',
  'review_typing',
]

export const QUIZ_STAGES: LexicalLearningQuizStage[] = [
  'quiz_matching',
  'quiz_meaning_to_lexical',
  'quiz_lexical_to_meaning',
]

export const REVIEW_STAGES: LexicalLearningReviewStage[] = [
  'review_speaking',
  'review_typing',
]
